import { Box, Button } from "@mui/material";
import Wrapper from "../components/Wrapper";
import { Link } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { getQuestions } from "../services/main-questionnaire";
import QuestionBox from "../components/QuestionBox";

const MainQuestionnaire = () => {

  const [questions, set_questions] = useState([]);

  const getQuestionsDetails = useCallback(async () => {
    const { data } = await getQuestions();
    set_questions(data.questions);
  }, [])

  useEffect(() => {
    getQuestionsDetails()
  }, [getQuestionsDetails])
  return (
    <Wrapper>
      <Box
        component='div'
        display='flex'
        justifyContent='flex-end'
      >
        <Link
          to='/main-questionnaire/add'
          className="d-inline-block"
        >
          <Button
            variant="contained"
          >
            Add New
          </Button>

        </Link>
      </Box>

      {
        questions.map((question) => {
          return (
            <QuestionBox
              question = {question}
              key={question._id}
              getData = {getQuestionsDetails}
            />
          )
        })
      }
    </Wrapper>
  )
}

export default MainQuestionnaire;